





















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class VipFooter extends Vue {
  @Prop() username
  showMask: boolean = false
  toApp() {
    window.location.href = 'http://m.ivydad.com/api/u/969'
  }
}
